export function resolveStoreName (booking) {
  if (!booking) return ''
  if (booking.store && booking.store.name) return booking.store.name
  if (booking.store_name) return booking.store_name
  if (booking.store_id) return 'Store #' + booking.store_id
  return ''
}

export function resolveStoreAddress (booking) {
  if (!booking) return ''
  if (booking.store_address) return booking.store_address
  if (booking.store && booking.store.address) return booking.store.address
  return ''
}



// WEBPACK FOOTER //
// ./src/constants/storeAddresses.js